import { DictionaryItem } from "../interfaces/dictionary.interface";

export function getDictionaryItem(item: keyof DictionaryItem) {
    const dictionary = dictionaryItems[item as keyof DictionaryItem];
    return dictionary;
}

const dictionaryItems: DictionaryItem = {
    addCase: "Opret sag",
    addImages: "Tilføj billeder",
    addFiles: "Tilføj filer",
    addNewFiles: "Tilføj nye filer",
    attachedFiles: "Vedhæftede filer",
    appTitle: "Supportsystem",
    area: "Område",
    articleUsefulText: "Var denne vejledning brugbar?",
    caseErrorText: "Der skete en fejl under oprettelsen af din sag. Prøv igen.",
    caseSubmittedText: "Din sag blev oprettet ",
    category: "Kategori",
    closeCase: "Annullér sag",
    searchMyCases: "Søg i mine sager",
    searchMyKnowledge: "Søg i vidensartikler",
    searchMyCourse: "Søg i kurser",
    knowledgeReadArticle: "Læs vejledning",
    minutesShort: "min.",
    show: "Vis",
    close: "Luk",
    caseErrorSumplementalText: "Hvis problemet fortsætter, kontakt venligst supporten.",
    frontpage: "Forside",
    knowledgeArticles: "Vidensartikler",
    closeCaseWarningText: "Er du sikker på du vil lukke din sag? Dine indtastede data vil blive slettet.",
    courses: "Kurser",
    registered: "Tilmeldte",
    register: "Tilmeld",
    unRegister: "Afmeld",
    userIsRegistrered: "Du er tilmeldt dette kursus",
    registeredAmount: "Antal tilmeldte",
    feedbackText: "Tak for din feedback!",
    coursePrice: "Kursuspris",
    date: "Dato",
    dateAndDuration: "Dato og varighed",
    description: "Beskrivelse",
    free: "Gratis",
    location: "Lokalitet",
    addToWaitlist: "Venteliste",
    courseSignupError: "Der skete en fejl under tilmeldingen til kurset. Prøv igen.",
    courseSignupSuccess: "Du er nu tilmeldt kurset",
    courseSignupWaitlist: "Du er nu på venteliste til kurset",
    headline: "Emne",
    caseTextErrorMessage: " felt er påkrævet og skal være mindst 10 tegn",
    isRequired: " felt er påkrævet",
    logoutFromApp: "Log ud af Supportsystem",
    loginToApp: "Log ind på Supportsystem",
    myCases: "Mine supportsager",
    name: "Navn",
    noDescription: "Ingen beskrivelse",
    selectArea: "Vælg forretningsområde",
    selectCategory: "Vælg kategori",
    selectWorks: "Vælg forsyning",
    solution: "Løsning",
    works: "Forsyninger",
    noCasesFound: "Ingen sager fundet",
    noCoursesFound: "Ingen kurser fundet",
    noArticlesFound: "Ingen artikler fundet",
    attendees: "Deltagere",
    skipToMainContent: "Gå til hovedindhold",
    frontpageArticlesHeader: "Lær mere",
    frontpageArticlesSubheader: "Se vejledning og guides i vores vidensdatabase.",
    frontpageCoursesHeader: "Kurser",
    frontpageTeamviewerHeader: "Start Teamviewer",
    frontpageTeamviewerSubheader: "Husk at åbne Teamviewer når du laver en sag",
    frontpageCoursesSubheader: "Se hvilke kurser/webinarer der passer til dig.",
    createCaseHelperText: "Udførelig beskrivelse over hvad henvendelsen drejer sig om.",
    noAccountsFoundHeader: "Vi kunne ikke finde et tilknyttet forsyning",
    noAccountsFoundText:
        "Der skete en fejl i forbindelse med login. Ingen tilknyttede forsyninger kunne findes på denne bruger. Hvis dette er en fejl, og du bør være tilknyttet et forsyning, bedes du kontakte Softværket support.",
    signupPeriod: "Tilmeldingsfrist",
    latest: "Senest",
    closedForSignup: "Lukket for tilmelding",
    anErrorOccurred: "Der opstod en fejl",
    belongingTo: "Tilknyttet",
    reportedBy: "Oprettet af",
    openTeamViewer: "Åben TeamViewer",
    updateUserProfile: "Opdater dine oplysninger",
    choseContactGroup: "Vælg dine kontaktgrupper",
    choseWorksArea: "Vælg arbejdsområde",
    choseContactMethod: "Vælg foretrukken kontaktmetode",
    firstname: "Fornavn",
    lastname: "Efternavn",
    email: "Email",
    mobilePhone: "Mobil Nr.",
    phoneNumber3: "Direkte Nr.",
    businessAreaFilterLabel: "Forretningsområder",
    contactPersons: "Dine kontaktpersoner",
    userDataUpdatedError: "Der skete en fejl i forbindelse med ændring af dine oplysninger. Prøv igen, eller hvis problemet fortsætter, kontakt Softværket.",
    userDataUpdatedSuccess: " oplysninger blev opdateret!",
    selectContact: "Vælg kontaktperson",
    notShowOnWebAttendees: "Vises ikke",
    notShowOnWebRegisterAttendee: "Vis ikke på web",
    showOnWebRegisterAttendee: "Vis på web",
    showOnWebText: "Må din tilmelding vises for andre? *",
    noActiveContactHeader: "Vi kunne ikke finde en aktiv konto",
    noActiveContactText: "Hvis du mener det er en fejl, bedes du kontakt Softværket support.",
    courseSortByDate: "Sorter efter dato",
    closeMessage: "Luk besked",
    messageCenter: "Beskedcenter",
    frontpageMessagesHeader: "Beskeder",
    frontpageMessagesSubheader: "Se alle beskeder i vores beskedcenter.",
    courseInstructor: "Kursusunderviser",
    smsAdvertisement: "SMS adviseringsnummer",
    customerReference: "Rekvisitionsnummer",
    remarks: "Bemærkninger",
    maxLengthExceeded: "Maksimal længde overskredet",
    dragOverlay: "Slip filerne for at vedhæfte dem til sagen",
    status: "Status",
    clearDateRange: "Ryd dato filter",
    clearAllFilters: "Ryd alle filtre",
    chosenFilters: "Valgte filtre"
};
